import { useQuery } from "@vue/apollo-composable";
import gql from "graphql-tag";
import { computed, type ComputedRef, type Ref } from "vue";
import type { SubscriptionPlan } from "@/types/subscription-types";

const LIST_SUBSCRIPTION_PLANS = gql`
  query ListSubscriptionPlans($currentSubscription: Boolean) {
    listSubscriptionPlans(currentSubscription: $currentSubscription) {
      currentSubscription {
        subscriptionPlanTierId
      }
      allPlans {
        name
        subscriptionPlanTiers {
          id
        }
      }
    }
  }
`;

export function useEnterprisePlan(): {
  isEnterprise: ComputedRef<boolean>;
  loading: Ref<boolean>;
} {
  const { result, loading } = useQuery(
    LIST_SUBSCRIPTION_PLANS,
    {
      currentSubscription: true,
    },
    {
      fetchPolicy: "network-only",
    }
  );

  const currentPlanName = computed(() => {
    const data = result.value?.listSubscriptionPlans;
    if (
      !data?.allPlans?.length ||
      !data?.currentSubscription?.subscriptionPlanTierId
    ) {
      return "";
    }
    const tierId = data.currentSubscription.subscriptionPlanTierId;
    for (const plan of data.allPlans as SubscriptionPlan[]) {
      if (
        plan.subscriptionPlanTiers?.some(
          (tier: { id: string }) => tier.id === tierId
        )
      ) {
        return plan.name || "";
      }
    }
    return "";
  });

  const isEnterprise = computed(() =>
    currentPlanName.value.includes("Enterprise Plan")
  );

  return {
    isEnterprise,
    loading,
  };
}
